module.exports = __webpack_public_path__ + "img/tea_yan.ec27d367.jpeg";